
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.528 3.52c4.683-4.684 12.275-4.686 16.96-.005 4.678 4.69 4.678 12.28 0 16.97-4.685 4.68-12.277 4.678-16.96-.005-4.682-4.684-4.682-12.276 0-16.96zm13.145 13.133a1 1 0 00.036-1.374l-3.11-3.11a.25.25 0 010-.352l3.11-3.11a1 1 0 10-1.414-1.415l-3.11 3.11a.25.25 0 01-.354 0l-3.11-3.11a1 1 0 00-1.41 1.415l3.11 3.11a.249.249 0 010 .353l-3.11 3.109a1 1 0 000 1.415c.396.38 1.021.38 1.416 0l3.109-3.11a.252.252 0 01.354 0l3.11 3.11a1 1 0 001.373-.041z","fill":"currentColor"}})])
          )
        }
      }
    